import React, { Fragment } from "react";
import { styled } from "@mui/material/styles";
import Link from "next/link";

import useShopContext from "@hooks/useShopContext";

const StyledImage = styled("img")(({ theme, logoSize }) => ({
  margin: theme.spacing(2),
  maxHeight: logoSize === "large" ? 96 : 64,
  "&:hover": {
    cursor: "pointer",
  },
  [theme.breakpoints.down("md")]: {
    maxHeight: logoSize === "large" ? 64 : 48,
    margin: theme.spacing(1),
  },
}));

const ShopLogo = ({ style }) => {
  const { shop } = useShopContext();

  if (!(shop?.logo || shop?.vendor?.company_photo)) {
    return <Fragment />;
  }

  return (
    <Link href="/">
      <StyledImage
        logoSize={shop?.logo_size}
        style={style}
        src={shop?.logo || shop?.vendor?.company_photo}
        alt={shop?.title}
      />
    </Link>
  );
};

export default ShopLogo;
